module.exports = __webpack_public_path__ + "static/media/hp.31c950d7.jpg";